import { create } from 'zustand';
import { Dependent } from '../types/dependents.types';

export interface OrderNewCardInstance {
  benefitId: string;
  dependents: Dependent[];
  vendorId: string;
  title: string;
  benefitSource: string;
  benefitType: string;
  isOpen: boolean;
  onComplete: (() => void) | undefined;
  elementToFocusOnClose?: HTMLElement | null;
}

export type LegacyOrderNewCardStore = {
  orderNewCardInstance: OrderNewCardInstance | undefined;
  setOrderNewCardInstance: (orderNewCardInstance: OrderNewCardInstance) => void;
  reset: () => void;
};

const initialState = {
  orderNewCardInstance: undefined,
};

export const legacyOrderNewCardStore = create<LegacyOrderNewCardStore>(
  (set) => ({
    ...initialState,
    setOrderNewCardInstance: (orderNewCardInstance: OrderNewCardInstance) =>
      set((state) => ({
        ...state,
        orderNewCardInstance: {
          ...state.orderNewCardInstance,
          ...orderNewCardInstance,
        },
      })),
    setIsOpen: (isOpen: boolean) =>
      set((state) => {
        const { orderNewCardInstance } = state;
        if (!orderNewCardInstance) {
          return state;
        }

        return {
          ...state,
          orderNewCardInstance: {
            ...orderNewCardInstance,
            isOpen,
          },
        };
      }),
    reset: () => set(() => ({ ...initialState })),
  }),
);

export const useGetLegacyOrderNewCardInstance = () => {
  const orderNewCardInstance = legacyOrderNewCardStore(
    (state) => state.orderNewCardInstance,
  );
  return orderNewCardInstance;
};

export const useLegacyOrderNewCardStoreActions = () => {
  const setOrderNewCardInstance = legacyOrderNewCardStore(
    (state) => state.setOrderNewCardInstance,
  );
  const reset = legacyOrderNewCardStore((state) => state.reset);
  return { setOrderNewCardInstance, reset };
};
